export default __webpack_public_path__ + "static/media/CheftasticRecreate.d96190a5.png";